/**
 * Pushes an event into the GTM dataLayer.
 *
 * Safe to call even when no GTM container is loaded — `dataLayer` is just a
 * plain array that the GTM snippet replays after it boots, so any push made
 * before (or without) GTM loading is harmless. Server-side calls are no-ops.
 */
export function pushDataLayer(event: string, payload?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return;
  const w = window as Window & { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ event, ...(payload || {}) });
}
